import ConfigParser from "logic/authentication/directoryServices/BackendConfigParser";
import Routes from "routing/Routes";
import BackendCreateLDAP from "./directoryServices/ldap/BackendCreate";
import BackendEditLDAP from "./directoryServices/ldap/BackendEdit";
import BackendConfigDetailsAD from "./directoryServices/activeDirectory/BackendConfigDetails";
import BackendConfigDetailsLDAP from "./directoryServices/ldap/BackendConfigDetails";
import BackendCreateAD from "./directoryServices/activeDirectory/BackendCreate";
import BackendEditAD from "./directoryServices/activeDirectory/BackendEdit";
export const PAGE_NAV_TITLE = "Authentication";
const bindings = {
  "authentication.services": [
    {
      name: "ldap",
      displayName: "LDAP",
      createComponent: BackendCreateLDAP,
      editComponent: BackendEditLDAP,
      configDetailsComponent: BackendConfigDetailsLDAP,
      configToJson: ConfigParser.toJson,
      configFromJson: ConfigParser.fromJson
    },
    {
      name: "active-directory",
      displayName: "Active Directory",
      createComponent: BackendCreateAD,
      editComponent: BackendEditAD,
      configDetailsComponent: BackendConfigDetailsAD,
      configToJson: ConfigParser.toJson,
      configFromJson: ConfigParser.fromJson
    }
  ],
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        { description: "Authentication Services", path: Routes.SYSTEM.AUTHENTICATION.BACKENDS.OVERVIEW },
        { description: "Authenticators", path: Routes.SYSTEM.AUTHENTICATION.AUTHENTICATORS.SHOW }
      ]
    }
  ]
};
export default bindings;
